"use client";
import { X } from "lucide-react";
import { ReactNode } from "react";
import Modal from "../../modal/Modal";
import MainButton from "@/components/customButton/CustomButton";

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  icon?: ReactNode;
  iconColor?: string;
}

export default function ConfirmModal({
  isOpen,
  onClose,
  title = "Are you sure?",
  message = "Do you really want to perform this action? This process cannot be undone.",
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  icon = <X size={32} />,
  iconColor = "#7B1E19",
}: ConfirmModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
        <div className="bg-white rounded-xl w-full max-w-2xl max-h-[80vh] overflow-y-auto shadow-xl p-6">
          {/* Close Button */}
          <div
            onClick={onClose}
            className="text-black cursor-pointer flex justify-end"
          >
            <X size={24} color="#7B1E19" />
          </div>

          {/* Icon */}
          <div className="flex justify-center">
            <div
              className="w-[70px] h-[70px] rounded-full border-4 flex justify-center items-center"
              style={{ borderColor: iconColor }}
            >
              {icon}
            </div>
          </div>
          <div className="text-center">
            <h2 className="mt-4 text-h4 text-mainHeading font-heading font-bold">
              {title}
            </h2>
            <p className="mt-4 text-paragraphFont text-paragraph font-heading">
              {message}
            </p>
          </div>

          <div className="flex gap-3 justify-center mt-5">
            <MainButton variant="outline" onClick={onClose}>
              {cancelText}
            </MainButton>
            <MainButton variant="primary" onClick={onConfirm}>
              {confirmText}
            </MainButton>
          </div>
        </div>
      </div>
    </Modal>
  );
}
